// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"0e411a17","398":"95a63053","481":"58875e26","561":"f5e80203","624":"e032545d","680":"9c9c1bec","841":"27d50cf6","874":"de34b018","881":"8b943a49","893":"aa3237e3","993":"571d26cc"}[chunkId] + ".chunk.js";
};